<mat-card appearance="outlined">
  <mat-card-content>
    <div class="content" fxLayout="column" fxLayoutAlign="center center">
      <p><i class="material-icons">{{ icon }}</i></p>
      <p>{{ message }}</p>
    </div>
  </mat-card-content>
</mat-card>
